import store from '@/store';
import * as _ from 'lodash';

export default roles => (to, from, next) => {
  if (to.path !== '/login') {
    if (Array.isArray(roles)) {
      if (_.intersectionWith(store.getters['account/roles'], roles, _.isEqual).length < 1) {
        next('/');
        return;
      }
    } else {
      if (!store.getters['account/roles'].includes(roles)) {
        next('/');
        return;
      }
    }
    next();
  } else {
    next();
  }
};
